/* eslint-disable @typescript-eslint/camelcase */
import { hasPermission } from '../services/permission'
import CONSTANTS from '~/constants'

// called as a constructor by ng
function contentApi($http, storyService, fn) {
  const onStoryErr = (reason) => {
    console.error('Could not get arc story', reason)
    throw reason
  }

  const postUrl = (story, redirect = false, websiteIdToRegenerateUrlFor) => {
    const redirectFrag = redirect ? '&redirect_existing=true' : ''

    // needs a date for can url, I tried setting it in backend and would not work, not sure why.
    // so setting it here to get the bug fixed.
    if (!story.publish_date) {
      const date =
        story.display_date ||
        story.first_publish_date ||
        new Date().toISOString()
      story.publish_date = date
    }

    const req = {
      method: 'POST',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/canonical-url/?websiteId=${websiteIdToRegenerateUrlFor}${redirectFrag}`,
      data: story,
      timeout: 100000,
    }
    return $http(req)
  }

  const testUrl = (story, websiteIdToRegenerateUrlFor, redirect = false) => {
    if (!story.publish_date) {
      const date =
        story.display_date ||
        story.first_publish_date ||
        new Date().toISOString()
      story.publish_date = date
    }

    if (story.canonical_url) {
      delete story.canonical_url
    }
    const redirectFlag = redirect ? '&redirect_existing=true' : ''
    const req = {
      method: 'POST',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/canonical-url/?websiteId=${websiteIdToRegenerateUrlFor}&test=true${redirectFlag}`,
      data: story,
      timeout: 100000,
    }
    return $http(req)
  }

  const deleteUrl = (story, websiteId) => {
    const req = {
      method: 'DELETE',
      data: { _id: story._id },
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/canonical-url/?websiteId=${websiteId}&url=${story.websites[websiteId].website_url}`,
      timeout: 100000,
    }
    return $http(req)
  }

  const getUrl = (story, websiteId) => {
    const req = {
      method: 'GET',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/canonical-url/?websiteId=${websiteId}&_id=${story._id}`,
      timeout: 100000,
    }
    return $http(req)
  }

  this.makeCanonicalUrl = (websiteId) => {
    return storyService.getStory().then((story) => {
      postUrl.call(this, story, false, websiteId)
    }, onStoryErr)
  }

  this.testCanonicalUrl = (websiteId, redirect) => {
    return storyService.getStory().then((story) => {
      return testUrl.call(this, story, websiteId, redirect)
    })
  }

  this.clearCanonicalUrl = (websiteId) => {
    return storyService.getStory().then((story) => {
      deleteUrl.call(this, story, websiteId)
    }, onStoryErr)
  }

  this.getCanonicalUrl = (websiteId) => {
    return storyService.getStory().then((story) => {
      getUrl.call(this, story, websiteId)
    }, onStoryErr)
  }

  this.regenerateWebsiteUrl = (websiteId) => {
    if (!hasPermission(window.userRolesAuth.story.urlRegeneration)) {
      return
    }

    const onStory = (story) => {
      const create = (websiteId) => {
        const clone = Object.assign({}, story)

        if (story.canonical_website === websiteId) {
          delete clone.canonical_url
        }

        return postUrl(clone, true, websiteId) // with redirect = true
      }

      const afterCreate = (response) => {
        console.info({ canonical_url_response: response })
        let newUrl = fn.at('data.website_url')(response)
        if (newUrl) {
          newUrl = newUrl.replace(/^\/\//, '/')

          if (story.canonical_website === websiteId) {
            story.canonical_url = newUrl
          }

          story.websites[websiteId].website_url = newUrl
          storyService.toggleUrlRegenFlag()
          storyService.save()
          return newUrl
        }
      }

      const past = (d) => d && new Date(d) < new Date()

      const pubDate = fn.at('publish_date')(story)
      const storyScheduledButNotPublished = !past(pubDate)
      const shouldDelete =
        story.websites[websiteId].website_url && storyScheduledButNotPublished

      if (shouldDelete) {
        return deleteUrl(story, websiteId)
          .then(create.bind(this, websiteId), (error) => {
            // Fun fact can_url can be set and not exist in the db!
            if (
              error &&
              error.data &&
              (error.data === 'url not found.' ||
                error.data.indexOf(`doesn't exist`) > -1)
            ) {
              story.websites[websiteId].website_url = ''
              return create(websiteId).then(afterCreate)
            } else {
              throw error
            }
          })
          .then(afterCreate)
      } else {
        return create(websiteId).then(afterCreate)
      }
    }

    return storyService.getStory().then(onStory, onStoryErr)
  }
}

export default [
  '$http', // ng-hooked http webclient
  'storyService',
  'fnService',
  contentApi, // our constructor below
]
